import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircle, Loader2, RefreshCw } from 'lucide-react';
import { API, euro } from '../lib/catalog';
import { apiError, emailStates } from '../lib/adminApi';
import { BankTransferDetails } from '../components/BankTransferDetails';
import { Button } from '../components/ui/button';

export default function BankOrderPage() {
  const { number } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const controller = new AbortController();
    const token = sessionStorage.getItem(`order-token:${number}`);
    setError(''); setLoading(true);
    if (!token) { setError('Ova narudžba nije dostupna u ovom pregledniku. Za podatke o uplati obratite nam se.'); setLoading(false); return; }
    axios.get(`${API}/order-confirmation/${encodeURIComponent(number)}`, { headers: { 'X-Order-Token': token }, signal: controller.signal })
      .then(r => setOrder(r.data)).catch(e => { if (!axios.isCancel(e)) setError(apiError(e)); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [number, attempt]);
  return <main className="bg-gray-50 min-h-screen py-10 sm:py-14">
    <div className="max-w-2xl mx-auto px-4 sm:px-6">
      {loading ? <p className="flex items-center gap-3" role="status" data-testid="bank-order-loading"><Loader2 className="animate-spin" />Učitavanje narudžbe...</p>
        : error ? <div role="alert" className="bg-white p-6 border rounded" data-testid="bank-order-error"><p>{error}</p><Button variant="outline" className="mt-5" onClick={() => navigate('/kontakt')} data-testid="bank-order-contact-button">Kontakt</Button></div>
        : order && <>
          <CheckCircle className="w-12 h-12 text-green-700 mb-5" aria-hidden="true" />
          <h1 className="text-3xl sm:text-4xl font-serif mb-4" data-testid="order-received-title">{order.status === 'pending' ? 'Narudžba primljena!' : order.status === 'cancelled' ? 'Narudžba otkazana' : 'Uplata potvrđena'}</h1>
          <p className="mb-2 text-sm text-gray-600">Broj narudžbe: <strong className="break-all text-gray-900" data-testid="order-number">{order.orderNumber}</strong></p>
          <p className="mb-6 text-sm text-gray-600" data-testid="order-contact-email">E-mail za potvrdu: <span className="break-all">{order.customerEmail}</span></p>
          {order.bankTransfer ? <BankTransferDetails orderNumber={number} amount={order.total} bankTransfer={order.bankTransfer} /> : <div className="border rounded p-6 bg-white">
            <p data-testid="bank-paid-total">Iznos: <strong>{euro(order.total)}</strong></p>
            <p className="text-sm text-gray-600 mt-3" data-testid="bank-paid-email-status">{order.status === 'cancelled' ? 'Narudžba je otkazana. Nemojte izvršiti uplatu.' : emailStates[order.emailStatus] || order.emailStatus}</p>
          </div>}
          <div className="flex flex-wrap gap-3 mt-6">
            <Button variant="outline" onClick={() => setAttempt(attempt + 1)} data-testid="bank-order-refresh"><RefreshCw size={16} />Provjeri status</Button>
            <Button onClick={() => navigate('/')} data-testid="order-return-home-button">Povratak na početnu</Button>
          </div>
        </>}
    </div>
  </main>;
}